import React from 'react';

import WsIconProps from './IconProps';

const Tag: React.FC<WsIconProps> = ({ color = '#888A8E', width = 16, height = 17 }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.00005 4.49969C4.80227 4.49969 4.60893 4.55833 4.44448 4.66822C4.28003 4.7781 4.15186 4.93428 4.07617 5.117C4.00048 5.29973 3.98068 5.50079 4.01927 5.69478C4.05785 5.88876 4.15309 6.06694 4.29294 6.20679C4.4328 6.34665 4.61098 6.44189 4.80496 6.48047C4.99894 6.51906 5.20001 6.49925 5.38274 6.42357C5.56546 6.34788 5.72164 6.2197 5.83152 6.05526C5.9414 5.89081 6.00005 5.69747 6.00005 5.49969C6.00005 5.23447 5.8947 4.98012 5.70716 4.79258C5.51962 4.60504 5.26527 4.49969 5.00005 4.49969ZM14.0801 7.63969L8.47339 2.02635C8.41109 1.96456 8.33721 1.91568 8.25599 1.8825C8.17477 1.84933 8.08779 1.83251 8.00005 1.83302H2.00005C1.82324 1.83302 1.65367 1.90326 1.52865 2.02828C1.40362 2.15331 1.33339 2.32287 1.33339 2.49969V8.49969C1.33288 8.58742 1.34969 8.6744 1.38287 8.75562C1.41605 8.83685 1.46493 8.91073 1.52672 8.97302L7.14005 14.5797C7.51505 14.9542 8.02338 15.1646 8.55339 15.1646C9.08339 15.1646 9.59172 14.9542 9.96672 14.5797L14.0801 10.4997C14.4546 10.1247 14.665 9.61635 14.665 9.08635C14.665 8.55635 14.4546 8.04802 14.0801 7.67302V7.63969ZM13.1401 9.51969L9.02005 13.633C8.89514 13.7572 8.72618 13.8269 8.55005 13.8269C8.37393 13.8269 8.20496 13.7572 8.08005 13.633L2.66672 8.22635V3.16635H7.72672L13.1401 8.57969C13.2018 8.64198 13.2507 8.71586 13.2839 8.79708C13.3171 8.87831 13.3339 8.96528 13.3334 9.05302C13.3326 9.22791 13.2632 9.39551 13.1401 9.51969Z"
      fill={color}
    />
  </svg>
);

export default Tag;
